<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class=" mr-auto">
    <button mat-raised-button routerLink="/hazardous_substances" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('hazardous-substances.list.account-title', 'Hazardous Substances') }}
    </button>

    <button
      mat-raised-button
      routerLink="/hazardous_substances/{{ hazardous_substance.id }}/view"
      *ngIf="hazardous_substance.id"
      class="m-1 mr-2">
      <mat-icon>visibility</mat-icon>
      View
    </button>

    <button
      mat-raised-button
      color="warn"
      (click)="onRemove()"
      *ngIf="hazardous_substance.id"
      class="m-1 mr-2">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
  </span>
</nav>

<div class="container-fluid p-3">
  <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">
    <div class="card">
      <div class="card-body form-container">
        <h5 class="card-title">{{ utils.getLangTerm('hazardous-substances.singular', 'Hazardous Substance') }} Form</h5>

        <div class="container-fluid p-0 pt-3">

          <div class="row">
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Substance / Product</mat-label>
                <input
                  matInput
                  placeholder="Substance / Product"
                  [(ngModel)]="hazardous_substance.substance"
                  name="substance"
                  type="text"
                  #substance
                  required/>
                <mat-hint>Please enter the name of the {{ utils.getLangTerm('hazardous-substances.singular', 'Hazardous Substance') }}.</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Type</mat-label>
                <mat-select
                  placeholder="Hazardous Substance Type"
                  [(ngModel)]="hazardous_substance.hazardous_substance_type"
                  name="hazardous_substance_type"
                  required
                  id="hazardous_substance_type"
                  (valueChange)="onChangeUnitType($event)">
                  <mat-option *ngFor="let hazardous_substance_type of utils.getHazardousSubstanceTypes()" [value]="hazardous_substance_type">
                    {{ '(' + ((hazardous_substance_type || '').substring(0, 1)) + ') ' + hazardous_substance_type }}
                  </mat-option>
                </mat-select>
                <mat-hint>Please select the type of {{ utils.getLangTerm('hazardous-substances.singular', 'Hazardous Substance') }}.</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Unit Type</mat-label>
                <mat-select
                  placeholder="Unit Type"
                  [(ngModel)]="hazardous_substance.hazardous_substance_unit_type"
                  name="hazardous_substance_unit_type"
                  required
                  id="hazardous_substance_unit_type">
                  <mat-option *ngFor="let hazardous_substance_unit_type of utils.getHazardousSubstanceUnitTypes()" [value]="hazardous_substance_unit_type">
                    {{ hazardous_substance_unit_type }}
                  </mat-option>
                </mat-select>
                <mat-hint>The default unit type is automatically inferred from the type.</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>What is the risk / related harm?</mat-label>
                <textarea
                  matInput
                  placeholder="What is the risk / related harm?"
                  [(ngModel)]="hazardous_substance.risk_info"
                  name="risk_info"
                  type="text"
                  rows="6"
                  #risk_info
                  required>
                </textarea>
                <mat-hint>Please enter the risk / related harm.</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Precautions for use</mat-label>
                <textarea
                  matInput
                  placeholder="Precautions for use"
                  [(ngModel)]="hazardous_substance.additional_info"
                  name="additional_info"
                  type="text"
                  rows="6"
                  #additional_info
                  required>
                </textarea>
                <mat-hint>Please enter the precautions for use.</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Enter the storage requirements</mat-label>
                <textarea
                  matInput
                  placeholder="Enter the storage requirements"
                  [(ngModel)]="hazardous_substance.storage_requirements"
                  name="storage_requirements"
                  type="text"
                  rows="6"
                  #storage_requirements>
                </textarea>
                <mat-hint>Please enter the storage requirements.</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>United Nation (UN) Class & Packaging Group</mat-label>
                <input
                  matInput
                  placeholder="United Nation (UN) Class & Packaging Group"
                  [(ngModel)]="hazardous_substance.un_classification"
                  name="un_classification"
                  type="text"
                  #un_classification />
                <mat-hint>Please enter the United Nation (UN) Class & Packaging Group.</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>GHS/HSNO Classification</mat-label>
                <input
                  matInput
                  placeholder="GHS/HSNO Classification"
                  [(ngModel)]="hazardous_substance.hsno_classification"
                  name="hsno_classification"
                  type="text"
                  #hsno_classification />
                <mat-hint>Please enter the GHS/HSNO Classification.</mat-hint>
              </mat-form-field>
            </div>
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>GHS/HSNO Approval # and Group Standard</mat-label>
                <input
                  matInput
                  placeholder="GHS/HSNO Approval # and Group Standard"
                  [(ngModel)]="hazardous_substance.hsno_approval_number"
                  name="hsno_approval_number"
                  type="text"
                  #hsno_approval_number />
                <mat-hint>Please enter the GHS/HSNO Approval # and Group Standard.</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-xl-4">
              <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Expiry Date of Safety Data Sheet (SDS)</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="selectedExpiryDate" [min]="currentDate" name="sds_expires_at" readonly>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <button type="button" matSuffix mat-icon-button *ngIf="selectedExpiryDate" (click)="selectedExpiryDate = null" matTooltip="Remove the date."><mat-icon>close</mat-icon></button>
                <mat-datepicker #picker></mat-datepicker>
                <mat-hint>Please select the expiry date of the Safety Data Sheet (SDS).</mat-hint>
              </mat-form-field>
            </div>
          </div>

        </div>

        <div class="mx-0 mt-0 mb-4">
          <mat-checkbox
            [(ngModel)]="hazardous_substance.link_to_all_sites"
            name="link_to_all_sites"
            class="my-2 ml-1 mr-2">
            Link to all {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }} or
          </mat-checkbox>

          <button
            mat-raised-button
            type="button"
            color="secondary"
            (click)="onSelectSites()"
            class="my-2 ml-1 mr-2"
            [matBadge]="'' + (hazardous_substance.link_to_all_sites ? 'All' : hazardous_substance.site_ids?.length)">
            <mat-icon>location_on</mat-icon>
            Select {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
          </button>
        </div>

        <div class="save-container">
          <button
            type="submit"
            mat-raised-button
            [disabled]="!f.valid || inProgress"
            color="primary"
            id="save"
            class="my-2 ml-1 mr-2">
            <mat-icon>save</mat-icon>
            Save
          </button>

          <button
            mat-raised-button
            (click)="onManagePPE()"
            color="secondary"
            [matBadge]="'' + (hazardous_substance?.ppe_ids?.length || '')"
            type="button"
            class="my-2 ml-1 mr-2">
            <mat-icon>headset</mat-icon>
            PPE
          </button>

          <app-file-browse-button
            (selectedFiles)="onSelectFiles($event)"
            (afterDialogClosedEvent)="onSubmit(f)"
            parentObjectType="hazardous_substance"
            [parentObjectId]="hazardous_substance?.id"
            [filesCount]="hazardous_substance?.files?.length">
          </app-file-browse-button>
        </div>
      </div>
    </div>
  </form>
</div>
